module.exports = "img/flags/VG.6899896.png";